import React from 'react';

import aampeTheme from '../../constants/aampeTheme';

import HeaderConfirmPrompt from './HeaderConfirmPrompt';
// components
import BasicModal from './basicModal';
import ConfirmPrompt from './confirmPrompt';

export type ConfirmModalTypes = 'warning' | 'success';

interface ConfirmModalProps {
    message: string;
    description?: string;
    confirm?: string;
    abort?: string;
    getUserConfirmation: (value: boolean) => void;
    type?: ConfirmModalTypes;
    showAbort?: boolean;
    showWarningButton?: boolean;
    showOutlinedButton?: boolean;
    className?: string;
    header?: string;
}

const ConfirmModal: React.FC<React.PropsWithChildren<ConfirmModalProps>> = ({
    type,
    message,
    description,
    confirm,
    abort,
    getUserConfirmation,
    showAbort = true,
    showWarningButton,
    showOutlinedButton,
    className,
    header,
}) => {
    return (
        <BasicModal
            className={className}
            header={header}
            containerBodyStyle={{ width: '480px' }}
            headerStyle={{
                backgroundColor: aampeTheme.colors.white,
                color: aampeTheme.colors.neutral09,
                fontWeight: aampeTheme.weights.medium,
                fontSize: aampeTheme.size.font.title,
                paddingBottom: 0,
            }}
        >
            {header ? (
                <HeaderConfirmPrompt
                    message={message}
                    description={description}
                    type={type}
                    abort={abort}
                    confirm={confirm}
                    abortHandler={
                        showAbort ? () => getUserConfirmation(false) : undefined
                    }
                    confirmHandler={() => getUserConfirmation(true)}
                    showWarningButton={showWarningButton}
                    showOutlinedButton={showOutlinedButton}
                ></HeaderConfirmPrompt>
            ) : (
                <ConfirmPrompt
                    message={message}
                    description={description}
                    type={type}
                    abort={abort}
                    confirm={confirm}
                    abortHandler={
                        showAbort ? () => getUserConfirmation(false) : undefined
                    }
                    confirmHandler={() => getUserConfirmation(true)}
                    showWarningButton={showWarningButton}
                    showOutlinedButton={showOutlinedButton}
                />
            )}
        </BasicModal>
    );
};

export default ConfirmModal;
